/**
 * Transforms a professional API model to an entity
 *
 * @param {import('../types/OnsiteInterviewList.api').IOnsiteInterviewProfessionalApiModel} model - API model
 * @returns {import('../types/OnsiteInterviewList').IOnsiteInterviewProfessionalEntity} Entity
 */
const toProfessionalEntity = (model) => ({
  id: model.id,
  fullName: model.fullName,
  firstName: model.firstName,
  lastName: model.lastName,
  profileImage: model.profileImage,
});

/**
 * Transforms an onsite interview API model to an entity
 *
 * @param {import('../types/OnsiteInterviewList.api').IOnsiteInterviewApiModel} model - API model
 * @returns {import('../types/OnsiteInterviewList').IOnsiteInterviewEntity} Entity
 */
const toOnsiteInterviewEntity = (model) => ({
  id: model.id,
  jobStatus: model.jobStatus,
  isLunchBreakPaid: model.isLunchBreakPaid,
  jobDatetime: model.jobDatetime,
  jobDatetimeEnd: model.jobDatetimeEnd,
  lunchFinalBreakTime: model.lunchFinalBreakTime,
  rate: model.rate,
  profession: model.profession,
  professionName: model.professionName,
  subProfession: model.subProfession,
  subProfessionName: model.subProfessionName,
  timezone: model.timezone,
  specialty: model.specialty,
  procedures: model.procedures,
  createdAt: model.createdAt,
  state: model.state,
  total: model.total,
  totalHours: model.totalHours,
  workingHours: model.workingHours,
  localStartTime: model.localStartTime,
  localEndTime: model.localEndTime,
  localDate: model.localDate,
  localTimezone: model.localTimezone,
  multiDayBooking: model.multiDayBooking,
  insuranceAmount: model.insuranceAmount,
  patientsPerHour: model.patientsPerHour,
  isFavorite: model.isFavorite,
  parkingInfo: model.parkingInfo,
  parkingType: model.parkingType,
  workerClassification: model.workerClassification,
  timePerPatient: model.timePerPatient,
  isAssistedHygiene: model.isAssistedHygiene,
  isUrgent: model.isUrgent,
  urgentShift: model.urgentShift,
  scheduled: model.scheduled,
  consent: model.consent,
  knowByTime: model.knowByTime,
  offerFinalReceiver: model.offerFinalReceiver,
  jobFilledDatetime: model.jobFilledDatetime,
  professional: model.professional ? toProfessionalEntity(model.professional) : undefined,
  candidatesCount: model.candidatesCount,
});

/**
 * Transforms onsite interview list API response to entity list with pagination
 *
 * @param {import('../types/OnsiteInterviewList.api').IGetOnsiteInterviewListApiResponse} response - API response
 * @returns {{ data: import('../types/OnsiteInterviewList').IOnsiteInterviewEntity[], page: number, limit: number, total: number }} Entity list with pagination
 */
const toOnsiteInterviewListResponse = (response) => ({
  data: response.data.map(toOnsiteInterviewEntity),
  page: response.page,
  limit: response.limit,
  total: response.total,
});

/**
 * Onsite Interview List Adapters
 * Provides transformation functions between API models and entities
 */
export const OnsiteInterviewListAdapters = {
  toProfessionalEntity,
  toOnsiteInterviewEntity,
  toOnsiteInterviewListResponse,
};
